// extracted by mini-css-extract-plugin
module.exports = {"content":"content-module--content--1IJI2","loading":"content-module--loading--2l4SS"};